// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout-module--main--3NgEk","footer":"Layout-module--footer--1ULzl","container":"Layout-module--container--9gWX_"};